<template>
    <ModalContainer id="previewModal">
        <section class="modal__content">
            <header class="modal__header">
                <h5 class="modal__title">{{ title }}</h5>
                <button
                    aria-label="Close"
                    class="btn--icon btn--ghost modal__close"
                    data-dismiss="modal"
                    type="button">
                    <i
                        aria-hidden="true"
                        class="icon icon-close"/>
                </button>
            </header>
            <section class="modal__body preview">
                <iframe
                    v-if="previewUrl"
                    :src="previewUrl"
                    allow="encrypted-media *; autoplay; fullscreen;"
                    allowfullscreen
                    frameborder="0"
                    height="440"
                    mozallowfullscreen
                    webkitallowfullscreen
                    width="100%"
                />
            </section>
        </section>
    </ModalContainer>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalContainer from '@/components/cms/common/Modal/ModalContainer';

export default {
    name: 'PreviewModal',
    components: {
        ModalContainer,
    },
    computed: {
        ...mapGetters('preview', ['title', 'previewUrl']),
    },
};
</script>
